import { NavLink } from "react-router-dom";
import { useCategories } from "@/lib/api";

export const CategoryStrip = () => {
  const cats = (useCategories() || []).filter((c) => !c.parent_path && c.count > 0);
  if (!cats.length) return null;
  return (
    <div className="border-t border-slate-100">
      <div className="no-scrollbar mx-auto flex max-w-7xl gap-2 overflow-x-auto px-4 py-2.5 sm:px-6" data-testid="category-strip">
        {cats.map((c) => (
          <NavLink key={c.slug} to={`/categoria/${c.slug}`} data-testid={`category-pill-${c.slug}`}
            className={({ isActive }) =>
              `shrink-0 rounded-full border px-3.5 py-1.5 text-xs font-medium transition-colors ${
                isActive ? "border-[#0066FF] bg-[#0066FF] text-white" : "border-slate-200 text-slate-700 hover:border-[#0066FF] hover:text-[#0066FF]"
              }`}>
            {c.name}
          </NavLink>
        ))}
      </div>
    </div>
  );
};
